import { Tab } from '../insight/experimental.tabset';
import { TabContext, TabType } from '../insight/tabset.model';

export interface PiTabConfig {
    identifier: string;
}

export function createTab(
    definitionIdentifier: string,
    category?: string,
    subCategory?: string,
    definition?: string,
): Tab<TabContext<PiTabConfig>> {
    const originalLabel = `${category || ''}${category ? '-' : ''}${
        subCategory || ''
    }${subCategory ? '-' : ''}${definition || ''}`.trim();
    return {
        id: `pi-${definitionIdentifier}-${Date.now()}`,
        ctx: {
            type: TabType.PERFORMANCE,
            originalLabel,
            label: originalLabel,
            config: {
                identifier: definitionIdentifier,
            },
        },
    };
}
